// extracted by mini-css-extract-plugin
export default {"addContainer":"SeriesPostManager-module__addContainer--9Wzgk"};